import script from "./InspectionViewerUpdateAnnotationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionViewerUpdateAnnotationForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__